<template>
    <div>
        <div class="row h1 page-header">
            Orders
        </div>

        <product-form v-if="addMode" @changed="reloadOrders()" :current="current"></product-form>

        <orders-list ref="ordersList" @edit="edit($event)"></orders-list>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                addMode: false,
                current: null
            }
        },

        methods: {
            showForm() {
                this.addMode = true;
            },

            hideForm() {
                this.addMode = false;
                this.current = null;
            },

            reloadOrders() {
                this.addMode = false;
                this.current = null;
                this.$refs.ordersList.getOrders();
            },

            edit(event) {
                this.addMode = true;
                this.current = event;
            }
        }
    }
</script>
